// Features and Amenities icons
import SaunaIcon from "./features/sauna.svg";
import CarpotIcon from "./features/carpot.svg";
import FloorsIcon from "./features/floors.svg";
import JacuzziIcon from "./features/jacuzzi.svg";
import LibraryIcon from "./features/library.svg";
import KitchenIcon from "./features/kitchen.svg";
import DogParkIcon from "./features/dog-park.svg";
import BathroomIcon from "./features/bathroom.svg";
import BedroomsIcon from "./features/bedrooms.svg";
import ElevatorIcon from "./features/elevator.svg";
import BoatDeckIcon from "./features/boat-deck.svg";
import GameRoomIcon from "./features/game-room.svg";
import FurnishedIcon from "./features/furnished.svg";
import FirePlaceIcon from "./features/fire-place.svg";
import ClubHouseIcon from "./features/club-house.svg";
import StoreRoomIcon from "./features/store-room.svg";
import StudyRoomIcon from "./features/study-room.svg";
import ChipFloorIcon from "./features/chip-floor.svg";
import DiningRoomIcon from "./features/dining-room.svg";
import UpsBatteryIcon from "./features/ups-battery.svg";
import GolfCourseIcon from "./features/golf-course.svg";
import OtherRoomsIcon from "./features/other-rooms.svg";
import WineCellarIcon from "./features/wine-cellar.svg";
import StaffRoomsIcon from "./features/staff-rooms.svg";
import UnfurnishedIcon from "./features/unfurnished.svg";
import CementFloorIcon from "./features/cement-floor.svg";
import TennisCourtIcon from "./features/tennis-court.svg";
import SolarPenalsIcon from "./features/solar-panels.svg";
import LaundryRoomIcon from "./features/laundry-room.svg";
import RooftopDeckIcon from "./features/rooftop-deck.svg";
import DrawingRoomIcon from "./features/drawing-room.svg";
import BarbecueAreaIcon from "./features/barbecue-area.svg";
import BreakfastBarIcon from "./features/breakfast-bar.svg";
import SwimmingPoolIcon from "./features/swimming-pool.svg";
import TileFlooringIcon from "./features/tile-flooring.svg";
import ParkingSpaceIcon from "./features/parking-space.svg";
import StorageUnitsIcon from "./features/storage-units.svg";
import WalkInClosetIcon from "./features/walk-in-closet.svg";
import SemiFurnishedIcon from "./features/semi-furnished.svg";
import SpaAndHotTubIcon from "./features/spa-and-hot-tub.svg";
import ParkingGarageIcon from "./features/parking-garage.svg";
import HardwoodFloorIcon from "./features/hardwood-floor.svg";
import GardenAndYardIcon from "./features/garden-and-yard.svg";
import InUnitLaundryIcon from "./features/in-unit-laundry.svg";
import OnSiteParkingIcon from "./features/on-site-parking.svg";
import CellarBasementIcon from "./features/cellar-basement.svg";
import GatedCommunityIcon from "./features/gated-community.svg";
import MarbleFlooringIcon from "./features/marble-flooring.svg";
import CentralHousingIcon from "./features/central-housing.svg";
import BicycleStorageIcon from "./features/bicycle-storage.svg";
import BusinessCenterIcon from "./features/business-center.svg";
import ConferenceRoomIcon from "./features/conference-room.svg";
import AirConditioningIcon from "./features/air-conditioning.svg";
import BackupGeneratorIcon from "./features/backup-generator.svg";
import BasketballCourtIcon from "./features/basketball-court.svg";
import BalconyAndPatioIcon from "./features/balcony-and-patio.svg";
import EnSuiteBathroomIcon from "./features/en-suite-bathroom.svg";
import ConciergeServiceIcon from "./features/concierge-service.svg";
import MediaRoomTheatreIcon from "./features/media-room-theatre.svg";
import SatelliteTvCableIcon from "./features/satellite-tv-cable.svg";
import LoungeSittingRoomIcon from "./features/lounge-sitting-room.svg";
import HighSpeedInternetIcon from "./features/high-speed-internet.svg";
import ChildrenPlaygroundIcon from "./features/children-playground.svg";
import TwentyFourHourSecurityIcon from "./features/24-hour-security.svg";
import PrivateBeachAccessIcon from "./features/private-beach-access.svg";
import SmartHomeTechnologyIcon from "./features/smart-home-technology.svg";
import GymAndFitnessCenterIcon from "./features/gym-and-fitness-center.svg";
import FacilitiesForDisabledIcon from "./features/facilities-for-disabled.svg";
import PetFriendlyFacilitiesIcon from "./features/pet-friendly-facilities.svg";
import StainlessSteelAppliancesIcon from "./features/stainless-steel-appliances.svg";
import GraniteQuartzaCounterTopsIcon from "./features/granite-quartza-countertops.svg";
import ElectricCarChargingStationIcon from "./features/electric-car-charging-station.svg";
import GarageCarportIcon from "./features/garage-carport.svg";

const FeaturesIconMapping = {
  sauna: SaunaIcon,
  floors: FloorsIcon,
  carport: CarpotIcon,
  jacuzzi: JacuzziIcon,
  library: LibraryIcon,
  dog_park: DogParkIcon,
  kitchens: KitchenIcon,
  bedrooms: BedroomsIcon,
  elevator: ElevatorIcon,
  bathrooms: BathroomIcon,
  game_room: GameRoomIcon,
  boat_dock: BoatDeckIcon,
  fireplace: FirePlaceIcon,
  clubhouse: ClubHouseIcon,
  storeRooms: StoreRoomIcon,
  study_room: StudyRoomIcon,
  otherRooms: OtherRoomsIcon,
  dining_room: DiningRoomIcon,
  wine_cellar: WineCellarIcon,
  golf_course: GolfCourseIcon,
  drawing_room: DrawingRoomIcon,
  rooftop_deck: RooftopDeckIcon,
  tennis_court: TennisCourtIcon,
  solar_panels: SolarPenalsIcon,
  spa_hot_tub: SpaAndHotTubIcon,
  laundry_room: LaundryRoomIcon,
  waste_disposal: WineCellarIcon,
  garden_yard: GardenAndYardIcon,
  parkingSpace: ParkingSpaceIcon,
  breakfast_bar: BreakfastBarIcon,
  storage_units: StorageUnitsIcon,
  barbecue_area: BarbecueAreaIcon,
  swimming_pool: SwimmingPoolIcon,
  walk_in_closet: WalkInClosetIcon,
  staffQuarters: StaffRoomsIcon,
  chip_flooring_type: ChipFloorIcon,
  parking_garage: ParkingGarageIcon,
  balcony_patio: BalconyAndPatioIcon,
  on_site_parking: OnSiteParkingIcon,
  in_unit_laundary: InUnitLaundryIcon,
  conference_room: ConferenceRoomIcon,
  central_heating: CentralHousingIcon,
  business_center: BusinessCenterIcon,
  gated_community: GatedCommunityIcon,
  bicycle_storage: BicycleStorageIcon,
  cellar_basement: CellarBasementIcon,
  cement_flooring_type: CementFloorIcon,
  tiles_flooring_type: TileFlooringIcon,
  basketball_court: BasketballCourtIcon,
  air_conditioning: AirConditioningIcon,
  backup_generator: BackupGeneratorIcon,
  en_suite_bathroom: EnSuiteBathroomIcon,
  ups_electricity_backup: UpsBatteryIcon,
  furnished_property_view: FurnishedIcon,
  wooden_flooring_type: HardwoodFloorIcon,
  concierge_service: ConciergeServiceIcon,
  satellite_cable_tv: SatelliteTvCableIcon,
  marble_flooring_type: MarbleFlooringIcon,
  media_room_theatre: MediaRoomTheatreIcon,
  solar_electricity_backup: SolarPenalsIcon,
  unfurnished_property_view: UnfurnishedIcon,
  high_speed_internet: HighSpeedInternetIcon,
  lounge_sitting_room: LoungeSittingRoomIcon,
  gym_fitness_center: GymAndFitnessCenterIcon,
  children_playground: ChildrenPlaygroundIcon,
  private_beach_access: PrivateBeachAccessIcon,
  "24_hour_security": TwentyFourHourSecurityIcon,
  smart_home_technology: SmartHomeTechnologyIcon,
  semi_furnished_property_view: SemiFurnishedIcon,
  generator_electricity_backup: BackupGeneratorIcon,
  facilities_for_disabled: FacilitiesForDisabledIcon,
  pet_friendly_facilities: PetFriendlyFacilitiesIcon,
  stainless_stell_appliances: StainlessSteelAppliancesIcon,
  granite_quartz_countertops: GraniteQuartzaCounterTopsIcon,
  electric_car_charging_station: ElectricCarChargingStationIcon,
  garage_carport: GarageCarportIcon
};

export default FeaturesIconMapping;
